import { auth } from '../utils/Constants';

export const getUserAuthorization = () => {
    const userdata = document.cookie.split(';').find((x) => x.trim().startsWith('userdata='));
    if (!userdata) return;

    const cookieString = decodeURIComponent(userdata).replace('userdata=', '');
    if (!cookieString) return;

    const cookie = JSON.parse(cookieString);
    if (!cookie || !cookie.authorizations) return;

    return Object.keys(cookie.authorizations);
};

export const validateAuthUser = (authorization) => {
    try {
        const authorizations = getUserAuthorization();
        return authorizations.includes(authorization);
    } catch (e) {
        return false;
    }
};

export const canEdit = () => {
    return validateAuthUser(auth.PPCP_ADMINISTRAR) || validateAuthUser(auth.PPCP_PLANEJADOR);
};
